// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2hU8e","content":"styles_content__ODTBv","checkbox":"styles_checkbox__3dJUL","checkboxLabel":"styles_checkboxLabel__hevc5"};